import { UserType } from '@quipex/shared/contracts';
import type { QuippySuggestedQuestion } from './models';
import { PERSONA_PROMPTS } from './personas';
import { CATEGORY_ICONS } from './personas/models';

type PromptScope = 'building' | 'portfolio';

export type QuippyPromptSuggestion = QuippySuggestedQuestion;

export function prepareQuippySuggestionDraft(text: string): string {
    return `${text.replace(/(?:…|\.\.\.)$/u, '').trimEnd()} `;
}

export function getQuippySuggestions(
    scope: PromptScope,
    userType: UserType | undefined
): readonly QuippyPromptSuggestion[] {
    const persona =
        userType !== undefined && Object.hasOwn(PERSONA_PROMPTS, userType)
            ? userType
            : UserType.Other;
    return PERSONA_PROMPTS[persona].map((definition, index) => ({
        id: `${scope}-${persona}-${index}`,
        text: definition[scope],
        category: definition.category,
        icon: CATEGORY_ICONS[definition.category],
        action: definition.action,
    }));
}
